module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_primaerlogo_neg.7f60ef2d.png";